<template>
    <div class="lanlord-map-search">
        <div class="lanlord-map-search-left">
            <map-house-menu></map-house-menu>
        </div>
        <div class="lanlord-map-search-right" >
            <map-search-filter></map-search-filter>
            <map-content ></map-content>
        </div>
    
    </div>
</template>
<script>
import MapHouseMenu from '@/components/landlord/landlordMapSearch/MapHouseMenu.vue';
import MapSearchFilter from '@/components/landlord/landlordMapSearch/MapSearchFilter.vue';
import MapContent from '@/components/landlord/landlordMapSearch/MapContent.vue';

export default {
    data () {
        return {
        }
    },
    mounted () {
        this.$analytics.logEvent('房源管理_地圖模式', { screen_name: '房源管理_地圖模式'})
        this.$store.dispatch('setHouseMgtMode', 2)
        this.$store.dispatch('getHouseMgtList')
    },
    components: {
        MapHouseMenu,
        MapSearchFilter,
        MapContent
    }
}
</script>
<style lang="scss" scoped>
    // body #app {
    //     width: 1920px !important;
    // }
    .lanlord-map-search{
        position: relative;
        display: flex;
        .lanlord-map-search-left{
            width: 400px;
            padding: 20px 0px;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            background-color: #ffffff;
            z-index: 2;
        }
        .lanlord-map-search-right{
            width: 1040px;
        }
    }
    @media screen and (max-width: 1280px) {
        .lanlord-map-search{
            .lanlord-map-search-right{
                width: 947px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/LandlordMapSearch.vue